'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const fpe=require('../../../../dist-es6/shared/extensions/fatiguePointExtensions');let

BiLevelLinePlotterDirective=function(_BaseControllerBacked){_inherits(BiLevelLinePlotterDirective,_BaseControllerBacked);function BiLevelLinePlotterDirective(){_classCallCheck(this,BiLevelLinePlotterDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(BiLevelLinePlotterDirective,[{key:'objectBindings',get:function()
{
return['points','threshold','dailyThresholds','ceiling','plotArea','verticalAxis','horizontalAxis','topStrokeWidth','bottomStrokeWidth'];
}},{key:'textBindings',get:function()
{
return['class','mask'];
}},{key:'controller',get:function()

{
return BiLevelLineController;
}}]);return BiLevelLinePlotterDirective}(BaseControllerBackedDirective);let


BiLevelLineController=function(){_createClass(BiLevelLineController,null,[{key:'$inject',get:function()
{
return['$scope'];
}}]);

function BiLevelLineController($scope){var _this2=this;_classCallCheck(this,BiLevelLineController);
this._splitPoints=null;
this._ceiling=null;
this._$scope=$scope;

$scope.$watch('controller.plotArea',function(){
if(_.exists(_this2.plotArea)){
_this2.plotArea.registerPlotter(_this2);
}
});
}BiLevelLineController.prototype.









redraw=function redraw(){var _this3=this;
if(!this._scalesValid){
return;
}

this._ceiling=this.verticalAxis.scale.invert(this.verticalAxis.offset+this.plotArea.axisLabelMargins.top+this.topStrokeWidth/2);

this._belowThresholdPoints=[];
this._atThresholdPoints=[];
this._aboveThresholdPoints=[];

for(const _ref of this.dailyThresholds){const{dayInterval:dayInterval,effectiveThreshold:effectiveThreshold}=_ref;
const pointsInDay=this.points.filter(function(tsp){return dayInterval.contains(tsp.time)});

const splitForDay=fpe(pointsInDay).splitByThresholds(effectiveThreshold);

_.pushMany(this._belowThresholdPoints,splitForDay.BelowOrNotApplicable);
_.pushMany(this._atThresholdPoints,splitForDay.At);
_.pushMany(this._aboveThresholdPoints,splitForDay.Above);
}

this._line=d3.svg.line().
interpolate('monotone').
x(function(point){return _this3.horizontalAxis.scale(point.time)}).
y(function(point){return _this3.verticalAxis.scale(Math.min(point.value,_this3._ceiling))}).
defined(function(point,i){return!(isNaN(point.value)||point.notRendered)});

this._group=d3.
select(this.plotArea.svgElement).
insert('g','.sleep').
attr({
class:`${this.class}`,
mask:`url(#${this.mask}-${this.plotArea.id})`});


this._group.
append('rect').
attr({

height:'100%',
width:'100%',
fill:'none'});


this._drawPath(this.points,Math.max(this.bottomStrokeWidth,this.topStrokeWidth)+4,'stroke-outline');
this._drawPath(this._belowThresholdPoints,this.bottomStrokeWidth,'below-threshold bottom');
this._drawPath(this._atThresholdPoints,this.topStrokeWidth,'at-threshold top');
this._drawPath(this._aboveThresholdPoints,this.topStrokeWidth,'above-threshold top');
};BiLevelLineController.prototype.

_drawPath=function _drawPath(points,width,additionalClass){
this._group.
append('path').
attr({
class:additionalClass,
fill:'none',
"stroke-width":width,
d:this._line(points)});

};_createClass(BiLevelLineController,[{key:'_scalesValid',get:function(){return _.exists(this.horizontalAxis)&&_.exists(this.horizontalAxis.scale)&&_.exists(this.verticalAxis)&&_.exists(this.verticalAxis.scale)}}]);return BiLevelLineController}();


module.exports=BiLevelLinePlotterDirective;
//# sourceMappingURL=biLevelLinePlotterDirective.js.map
